import { t as e } from "./cx-BjmrJCen.js";
/* empty css                              */
import { t } from "./text.css-DDuHJ-lZ.js";
import { jsx as n, jsxs as r } from "react/jsx-runtime";
//#region src/components/surfaces/surfaces.css.ts
var i = "ncmdhn0", a = "ncmdhn1", o = "ncmdhn2", s = "ncmdhn3", c = "ncmdhn5", l = "ncmdhn6", u = "ncmdhn7", d = "ncmdhn8", f = "ncmdhn9", p = "ncmdhna", m = "ncmdhnb", h = "ncmdhnc", g = "ncmdhnd", _ = "ncmdhne", v = "ncmdhnf", y = "ncmdhng", b = "ncmdhni", x = "ncmdhnj", S = "ncmdhnk", C = "ncmdhnl", w = "ncmdhnm", T = "ncmdhnn", E = "ncmdhno", D = "ncmdhnp", O = "ncmdhnr", k = "ncmdhns", A = "ncmdhnt", j = "ncmdhnu", ee = "ncmdhnv", M = "ncmdhnx";
//#endregion
//#region src/components/surfaces/surfaces.tsx
function N({ children: t, className: r, ...i }) {
	return /* @__PURE__ */ n("section", {
		...i,
		className: e(a, r),
		children: t
	});
}
function P({ children: t, className: r, empty: a = !1, ...o }) {
	return /* @__PURE__ */ n("section", {
		...o,
		className: e(i, a && "ncmdhn4", r),
		children: t
	});
}
function F({ children: t, className: r, ...i }) {
	return /* @__PURE__ */ n("section", {
		...i,
		className: e(o, r),
		children: t
	});
}
function I({ children: t, className: r, ...i }) {
	return /* @__PURE__ */ n("section", {
		...i,
		className: e(s, r),
		children: t
	});
}
function L({ children: t, className: r, ...i }) {
	return /* @__PURE__ */ n("section", {
		...i,
		className: e(a, v, r),
		children: t
	});
}
function R({ children: t, className: r, ...i }) {
	return /* @__PURE__ */ n("div", {
		...i,
		className: e(c, r),
		children: t
	});
}
function z({ children: t, className: r, ...i }) {
	return /* @__PURE__ */ n("div", {
		...i,
		className: e(l, r),
		children: t
	});
}
function B({ children: t, className: r, ...i }) {
	return /* @__PURE__ */ n("div", {
		...i,
		className: e(u, r),
		children: t
	});
}
function V({ children: t, className: r, ...i }) {
	return /* @__PURE__ */ n("div", {
		...i,
		className: e(d, r),
		children: t
	});
}
function H({ children: t, className: r, ...i }) {
	return /* @__PURE__ */ n("div", {
		...i,
		className: e(p, r),
		children: t
	});
}
function U({ children: r, className: i, ...a }) {
	return /* @__PURE__ */ n("p", {
		...a,
		className: e(t, f, i),
		children: r
	});
}
function W({ children: t, className: r, ...i }) {
	return /* @__PURE__ */ n("section", {
		...i,
		className: e(m, r),
		children: t
	});
}
function G({ children: t, className: r, ...i }) {
	return /* @__PURE__ */ n("div", {
		...i,
		className: e(h, r),
		children: t
	});
}
function K({ children: t, className: r, ...i }) {
	return /* @__PURE__ */ n("form", {
		...i,
		className: e(g, r),
		children: t
	});
}
function q({ children: t, className: r, ...i }) {
	return /* @__PURE__ */ n("div", {
		...i,
		className: e(_, r),
		children: t
	});
}
function J({ active: t = !1, children: r, className: i, ...a }) {
	return /* @__PURE__ */ n("article", {
		...a,
		className: e(y, t && "ncmdhnh", i),
		children: r
	});
}
function Y({ children: t, className: r, ...i }) {
	return /* @__PURE__ */ n("div", {
		...i,
		className: e(b, r),
		children: t
	});
}
function X({ children: t, className: r, ...i }) {
	return /* @__PURE__ */ n("div", {
		...i,
		className: e(x, r),
		children: t
	});
}
function Z({ children: t, className: r, ...i }) {
	return /* @__PURE__ */ n("div", {
		...i,
		className: e(S, r),
		children: t
	});
}
function Q({ children: t, className: r, ...i }) {
	return /* @__PURE__ */ n("form", {
		...i,
		className: e(C, r),
		children: t
	});
}
function $({ children: t, className: r, ...i }) {
	return /* @__PURE__ */ n("div", {
		...i,
		className: e(w, r),
		children: t
	});
}
function te({ children: t, className: r, ...i }) {
	return /* @__PURE__ */ n("div", {
		...i,
		className: e(T, r),
		children: t
	});
}
function ne({ children: t, className: r, ...i }) {
	return /* @__PURE__ */ n("ul", {
		...i,
		className: e(E, r),
		children: t
	});
}
function re({ children: t, className: r, completed: i = !1, ...a }) {
	return /* @__PURE__ */ n("li", {
		...a,
		className: e(D, i && "ncmdhnq", r),
		children: t
	});
}
function ie({ className: t, ...i }) {
	return /* @__PURE__ */ r("label", {
		className: e(O, t),
		children: [/* @__PURE__ */ n("input", {
			...i,
			className: k,
			type: "checkbox"
		}), /* @__PURE__ */ n("span", { className: A })]
	});
}
function ae({ children: t, className: r, ...i }) {
	return /* @__PURE__ */ n("div", {
		...i,
		className: e(j, r),
		children: t
	});
}
function oe({ children: t, className: r, ...i }) {
	return /* @__PURE__ */ n("div", {
		...i,
		className: e(M, r),
		children: t
	});
}
function se({ children: t, className: r, completed: i = !1, type: a, ...o }) {
	return /* @__PURE__ */ n("button", {
		...o,
		className: e(ee, i && "ncmdhnw", r),
		type: a ?? "button",
		children: t
	});
}
//#endregion
export { N as AppPanel, H as BoardBadges, U as BoardCopy, V as BoardHeader, P as BoardPanel, Q as Composer, te as ComposerRow, $ as ComposerShell, z as MetricsGrid, B as ShareHeader, I as SharePanel, K as StackForm, R as SyncHeader, F as SyncPanel, oe as TodoActions, ae as TodoContent, ne as TodoList, re as TodoRow, se as TodoTextButton, ie as TodoToggle, Z as VaultActions, Y as VaultCardHeader, J as VaultCardSurface, q as VaultGrid, L as VaultListPanel, X as VaultMeta, G as VaultStack, W as VaultsLayout };

//# sourceMappingURL=surfaces.js.map